import React from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import FullButton from "../Buttons/FullButton";
import TestimonialSlider from "../Elements/TestimonialSlider";

export default function Blog() {
  return (
    <Wrapper id="blog">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Latest Insights</h1>
            <p className="font13">
              Stay updated with the latest news, innovations, and insights from our software and web development projects.
              <br />
              We’re always working on exciting new solutions to meet our client needs.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="New Software Launch!"
                text="Discover the features of our latest software release designed to improve team productivity and streamline workflows."
                tag="Software"
                author="Jane Doe, 2 days ago"
                action={() => alert("Read more")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Design Trends of 2024"
                text="Learn about the latest trends in web and graphic design and how we incorporate them into our projects for our clients."
                tag="Design"
                author="John Smith, 1 week ago"
                action={() => alert("Read more")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Web Development Best Practices"
                text="Check out our tips and best practices for building scalable, fast, and user-friendly websites."
                tag="Web Dev"
                author="Alex Brown, 3 weeks ago"
                action={() => alert("Read more")}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Tech for Business Growth"
                text="How businesses are using cutting-edge technology to scale operations and increase revenue."
                tag="Tech"
                author="Emily White, 1 month ago"
                action={() => alert("Read more")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Mobile App Development Trends"
                text="Explore the latest mobile app development trends and how they can transform user experiences."
                tag="App Dev"
                author="Mark Green, 2 months ago"
                action={() => alert("Read more")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="AI in Software Development"
                text="Discover how artificial intelligence is revolutionizing software development and improving automation."
                tag="AI"
                author="Sophia Clark, 3 months ago"
                action={() => alert("Read more")}
              />
            </div>
          </div>
          <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "200px" }}>
              <FullButton title="See More Insights" action={() => alert("More articles coming soon!")} />
            </div>
          </div>
        </div>
      </div>
      <div className="lightBg" style={{ padding: '50px 0' }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">What Our Clients Say</h1>
            <p className="font13">
              Our clients are at the heart of everything we do. Here’s what they say about working with us.
              <br />
              We’re proud to be part of their success stories.
            </p>
          </HeaderInfo>
          <TestimonialSlider />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  text-align: center;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
